"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _Button = _interopRequireDefault(require("@insided/shared/uikit/Button"));

var _Switcher = _interopRequireDefault(require("@insided/deprecated-preact-components/control/Switcher"));

var _axios = _interopRequireDefault(require("axios"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var NotificationEnablePanelWrapper = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(NotificationEnablePanelWrapper, _Component);

  var _super = _createSuper(NotificationEnablePanelWrapper);

  function NotificationEnablePanelWrapper() {
    var _this;

    (0, _classCallCheck2.default)(this, NotificationEnablePanelWrapper);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      loading: false,
      showDetails: false,
      error: false,
      saved: false
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "setShowDetails", function () {
      _this.setState(function (prevState) {
        return _objectSpread(_objectSpread({}, prevState), {}, {
          showDetails: !prevState.showDetails
        });
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "toggleEnablement", function () {
      _this.props.setIsEnabled(!_this.props.isEnabled);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "saveNotificationData", /*#__PURE__*/function () {
      var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(data, notificationType) {
        var dataWithIds;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                dataWithIds = data === null || data === void 0 ? void 0 : data.map(function (item) {
                  return _objectSpread(_objectSpread({}, item), {}, {
                    id: item.type === 'email' ? 0 : 1,
                    active: item.type === notificationType ? _this.props.isEnabled : item.active
                  });
                });
                _context.prev = 1;
                _context.next = 4;
                return _axios.default.post('/integration/bitoolsconnector/notificationConfiguration', {
                  targets: dataWithIds
                });

              case 4:
                _context.next = 10;
                break;

              case 6:
                _context.prev = 6;
                _context.t0 = _context["catch"](1);
                console.error(_context.t0);

                _this.props.setRequestState({
                  type: 'danger',
                  title: 'Failed to submit data',
                  message: 'Please try again later. If the problem continues, contact support'
                });

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[1, 6]]);
      }));

      return function (_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }());
    return _this;
  }

  (0, _createClass2.default)(NotificationEnablePanelWrapper, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          title = _this$props.title,
          header = _this$props.header,
          inputFields = _this$props.inputFields,
          getData = _this$props.getData,
          clearFields = _this$props.clearFields,
          notificationType = _this$props.notificationType;
      return (0, _preact.h)("div", {
        className: "panel-body-container"
      }, (0, _preact.h)("div", {
        className: "panel-body-flex-container"
      }, (0, _preact.h)("div", {
        className: "title-bold"
      }, title), (0, _preact.h)("div", {
        className: "flex-row"
      }, (0, _preact.h)("div", {
        className: "preact-flag preact-flag-".concat(this.props.isEnabled ? 'success' : 'secondary')
      }, this.props.isEnabled ? 'ON' : 'OFF'), (0, _preact.h)(_Button.default, {
        size: "medium",
        icon: "chevronDown",
        onClick: function onClick() {
          return _this2.setShowDetails();
        },
        outlined: false,
        className: "button-border-none show-hide-btn-no-outline",
        oldStyle: true
      }))), this.state.showDetails && (0, _preact.h)("div", {
        className: "panel-body-description"
      }, (0, _preact.h)("div", {
        className: "data-lake-head-wrapper"
      }, header), inputFields.map(function (field) {
        return (0, _preact.h)("div", {
          className: "data-lake-input-wrapper",
          key: field.label
        }, (0, _preact.h)("div", {
          className: "athena-params"
        }, (0, _preact.h)("label", null, field.label, field.required && (0, _preact.h)("span", {
          className: "required-asterisk"
        }, "*")), (0, _preact.h)("div", {
          className: "row-flex"
        }, field.element)));
      }), (0, _preact.h)("div", {
        className: "athena-params"
      }, (0, _preact.h)("div", {
        className: "enable"
      }, (0, _preact.h)(_Switcher.default, {
        disable: this.props.requestState.type === 'info',
        onChange: function onChange() {
          if (_this2.props.canBeEnabled) {
            _this2.toggleEnablement();
          } else {
            // this.setState({
            //   isEnabled: false
            // })
            _this2.props.setIsEnabled(false);
          }
        },
        on: this.props.isEnabled
      }), (0, _preact.h)("div", {
        className: "enable-content"
      }, !this.props.canBeEnabled && (0, _preact.h)("div", {
        className: "enable-text"
      }, "Add all mandatory values to Enable"), this.props.canBeEnabled && !this.props.isEnabled && (0, _preact.h)("div", {
        className: "enable-text"
      }, "Click to Enable"), this.props.isEnabled && (0, _preact.h)("div", {
        className: "enable-text"
      }, "Enabled"))), (0, _preact.h)("div", {
        className: "flex-row"
      }, (0, _preact.h)(_Button.default, {
        size: "medium",
        variant: "primary",
        className: "show-hide-btn-no-outline",
        title: "Save Changes",
        onClick: function onClick() {
          var data = getData();

          _this2.saveNotificationData(data, notificationType);

          _this2.props.setRequestState({
            type: 'info',
            title: 'Saving in Progress...',
            message: 'Please wait a moment before trying to save again.'
          });

          _this2.setState({
            saved: true
          });
        },
        isLoading: this.props.requestState.type === 'info',
        outlined: false,
        disabled: !this.props.canSaveData || this.props.requestState.type === 'info' || this.state.saved
      }), (0, _preact.h)(_Button.default, {
        size: "medium",
        variant: "secondary",
        className: "show-hide-btn-no-outline",
        title: "Cancel",
        onClick: function onClick() {
          clearFields();
        },
        outlined: false,
        disabled: !this.props.canSaveData || this.props.requestState.type === 'info' || this.state.saved
      })))));
    }
  }]);
  return NotificationEnablePanelWrapper;
}(_preact.Component);

var _default = NotificationEnablePanelWrapper;
exports.default = _default;